export default "__VITE_ASSET__bvRX2aUB__"